var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9141 4.20575C10.8599 4.15108 10.7953 4.10768 10.7243 4.07807C10.6532 4.04845 10.5769 4.0332 10.4999 4.0332C10.4229 4.0332 10.3467 4.04845 10.2756 4.07807C10.2045 4.10768 10.14 4.15108 10.0858 4.20575L5.73993 8.55742L3.9141 6.72575C3.85779 6.67136 3.79133 6.6286 3.71849 6.59989C3.64566 6.57119 3.56789 6.55712 3.48962 6.55847C3.41135 6.55982 3.33411 6.57658 3.26231 6.60779C3.19052 6.63899 3.12557 6.68403 3.07118 6.74034C3.01679 6.79664 2.97402 6.86311 2.94532 6.93594C2.91662 7.00877 2.90254 7.08654 2.9039 7.16481C2.90525 7.24309 2.92201 7.32032 2.95321 7.39212C2.98442 7.46392 3.02946 7.52886 3.08576 7.58325L5.32576 9.82325C5.37999 9.87793 5.44451 9.92132 5.51559 9.95094C5.58668 9.98055 5.66292 9.9958 5.73993 9.9958C5.81694 9.9958 5.89318 9.98055 5.96427 9.95094C6.03535 9.92132 6.09987 9.87793 6.1541 9.82325L10.9141 5.06325C10.9733 5.00863 11.0206 4.94233 11.0529 4.86854C11.0852 4.79475 11.1019 4.71506 11.1019 4.6345C11.1019 4.55394 11.0852 4.47426 11.0529 4.40047C11.0206 4.32667 10.9733 4.26038 10.9141 4.20575Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.0ae48840357bc6831357e755c19dd4ce.svg";
export { ForwardRef as ReactComponent };